module.exports = __webpack_public_path__ + "img/info-circle-solid.756446af.svg";